import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-canvas-footer"]
const _hoisted_2 = { class: "flex justify-start" }
const _hoisted_3 = { class: "mr-3" }
const _hoisted_4 = { class: "text-right" }


export default {
  __name: 'PageFooter',
  props: {
  sticky: {
    type: Boolean,
    default: false
  },
  contentWidth: {
    type: String,
    default: ''
  }
},
  setup(__props) {



return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", {
    "data-canvas-footer": __props.contentWidth ? '' : undefined,
    class: _normalizeClass([
      !__props.contentWidth && 'border-t border-gray-100',
      __props.sticky && 'sticky bottom-0 z-10',
      __props.sticky && !__props.contentWidth && 'bg-gray-50'
    ])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["py-3", __props.contentWidth ? 'px-6 md:px-8' : 'px-4 sm:px-6 bg-gray-50'])
    }, [
      _createElementVNode("div", {
        "data-footer-row": "",
        class: _normalizeClass(["flex justify-between", __props.contentWidth])
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _renderSlot(_ctx.$slots, "left")
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "right")
        ])
      ], 2)
    ], 2)
  ], 10, _hoisted_1))
}
}

}